import useSWR from 'swr'
import { SOUNDSTORE } from 'app/constants/LOCALKEYS'
import { getPersistData } from '../persist'

const KEY = SOUNDSTORE + '3'

let swrData: any = getPersistData(KEY) || 0
export function useTicketStore(initData?: any) {
	const { data, mutate } = useSWR<any>(KEY, async () => {
		if (initData !== undefined) {
			swrData = initData
		}
		return swrData
	})

	return {
		data,
		mutate: (value: any) => {
			swrData = value
			return mutate()
		},
	}
}
